import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { axiosConnectorInstance } from "../App";

export default function RedirectPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // from url get code
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    // read cliend_id and client_secret from session storage
    const client_id = localStorage.getItem("client_id");
    const client_secret = localStorage.getItem("client_secret");
    const connectionUuid = localStorage.getItem("connectionUuid");

    axiosConnectorInstance("/authorize", {
      params: {
        code: code,
        connectionUuid: connectionUuid,
        client_id: client_id,
        client_secret: client_secret,
      },
    }).then((res) => {
      // remove client_id and client_secret from session storage
      localStorage.removeItem("client_id");
      localStorage.removeItem("client_secret");

      // set trimbleToken in local storage if it is not empty
      if (res) {
        // if res is ok navigate to /trimble/projects
        navigate("/trimble/projects");
      }
    });
  }, [navigate]);

  return (
    <div>
      <h1>Redirect page</h1>
    </div>
  );
}
